import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import GoogleAd from "components/googleAd/GoogleAd";
import Card from "components/card/Card";
import { PageCollapseWidth } from "../../constants";
import { useAppDispatch, useAppSelector } from "hooks";
import encodeSlice from "reducers/encodeSlice";
import { RootState } from "store";
import {
  busySelector,
  errorSelector,
  outputSelector,
} from "selectors/encodeSelectors";
import EncodeOutput from "components/encodeOutput/EncodeOuput";
import EncodeInput from "components/encodeInput/EncodeInput";
import UrlDecodeInfo from "components/urlDecodeInfo/UrlDecodeInfo";

const UrlDecodePage = () => {
  const dispatch = useAppDispatch();

  const handleSubmit = (input: any) => {
    dispatch(encodeSlice.actions.urlDecode({ input }));
  };

  const busy = useAppSelector((state: RootState) => busySelector(state));

  const error = useAppSelector((state: RootState) => errorSelector(state));

  const output = useAppSelector((state: RootState) => outputSelector(state));

  return (
    <>
      <Helmet>
        <title>
          URL Decode Online – Convert Encoded URLs to Text | ToolWeaver
        </title>
        <meta
          name="description"
          content="Free online URL decoder. Decode URL-encoded text instantly. Your input is processed to produce the result and is not stored."
        />
        <link rel="canonical" href="https://toolweaver.com/urldecode" />
      </Helmet>
      <Page>
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card collapseOnWidth={PageCollapseWidth} title="URL Decoder">
          {!output && (
            <EncodeInput
              onSubmit={handleSubmit}
              busy={busy}
              error={error}
              buttonText="Decode"
              header="Enter your encoded piece of text and click the 'Decode' button."
            />
          )}
          {output && (
            <EncodeOutput
              output={output}
              header="Your decoded text is below."
            />
          )}
        </Card>

        <GoogleAd showOnWidth={PageCollapseWidth} type="medium-rectangle" />
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card
          isLast={true}
          collapseOnWidth={PageCollapseWidth}
          title="How does URL decoding work?"
          headingLevel={2}
        >
          <UrlDecodeInfo />
        </Card>
      </Page>
    </>
  );
};

export default memo(UrlDecodePage);
